export const formateDate = (date: string): string => {
  const tempDate = new Date(date)
  let day = tempDate.getDay()
  let month = tempDate.getMonth()
  let year = tempDate.getFullYear()

  return day + '/' + month + '/' + year
}

export const formatDateWithTimeAndDate = (date: string): string => {
  const newDate = new Date(date)
  return newDate.toDateString() + ', ' + newDate.toLocaleTimeString()
}
